module.exports = __webpack_public_path__ + "img/my-mentor-icon.15ffa6a5.svg";